import React, { Component } from 'react';
import FileUploaderBlob from './../../../commons/FileUploaderBlob.js';

export default class StockTake extends Component {
	render() {
		return(
			<div className="dump-ingestion-wrapper">
				<div className="white-box">
					<div className="page-header-title">
						Stock Take Adhoc Ingestion
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="stock-take/adhoc-request-ingestion"/>
					</div>
				</div>
				<div className="white-box margin-top-thirty">
					<div className="page-header-title">
						StockTake at Product And Facility Level
					</div>
					<div className="top-thirty">
						<FileUploaderBlob url="stock-take/session-request-ingestion"/>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/screens/InventoryOperations/Components/StockTake.js